/**
 * src/GuidanceSystem.js
 * Visual onboarding that "holds the hand" of the user using Bauhaus cues.
 * Follows the "Nobody Reads" principle: uses pulses and arrows instead of text.
 */

export const GuidanceSystem = {
    update(economy, ui) {
        if (!ui || !economy) return;
        const state = economy.exportState();
        
        // 1. Clear previous guidance
        this.clearGuidance(ui);

        // 2. Logic-based Guidance
        let objectiveText = "OBJETIVO: EXPLORAR HOSPITAL";

        // New User -> Start Guard
        if (state.playerLevel === 1 && (state.lifetimeCleanCases || 0) === 0) {
            this.applyGuidance(ui.runGuard, "EMPIEZA AQUÍ");
            objectiveText = "Siguiente: Realiza tu primera guardia";
        }
        // Has Credits & Empty Roster -> Recruitment
        else if (state.credits >= 100 && Object.keys(state.roster || {}).length === 0) {
            this.applyGuidance(ui.menuBtnHub, "RECLUTAR");
            objectiveText = "Siguiente: Contrata a tu primer mentor";
        }
        // SP Available -> Talent Tree
        else if (state.skillPoints >= 1 && state.playerLevel >= 2) {
             // We don't want to pulse too many things
             // but if it's the first time they have SP...
             if (!localStorage.getItem('guidance_perks_seen')) {
                 this.applyGuidance(ui.menuBtnHub, "TALENTOS");
                 objectiveText = "Siguiente: Mejora tus habilidades";
             }
        }

        // Update HUD Hinter — always visible with current objective
        if (ui.objectiveHinter) {
            ui.objectiveHinter.textContent = objectiveText;
            ui.objectiveHinter.style.display = objectiveText ? 'flex' : 'none';
        }
    },

    applyGuidance(element, label) {
        if (!element) return;
        element.classList.add('bauhaus-pulse');
        
        // Add arrow if not present
        if (!element.querySelector('.guide-arrow')) {
            const arrow = document.createElement('div');
            arrow.className = 'guide-arrow';
            element.style.position = 'relative'; 
            element.appendChild(arrow);
        }
    },

    clearGuidance(ui) {
        const guided = document.querySelectorAll('.bauhaus-pulse');
        guided.forEach(el => {
            el.classList.remove('bauhaus-pulse');
            const arrow = el.querySelector('.guide-arrow');
            if (arrow) arrow.remove();
        });
    }
};
